// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"peopleCheckbox_checkboxContainer__1JAe3","checkbox":"peopleCheckbox_checkbox__2lQCZ","label":"peopleCheckbox_label__IoIbi","dot":"peopleCheckbox_dot__2wODd"};